import React from 'react';

// Hizmet görselleri
import evTasima from '../assets/images/services/ev-tasima.jpg';
import ofisTasima from '../assets/images/services/ofis-tasima.jpg';
import asansorluTasima from '../assets/images/services/asansorlu-tasima.jpg';
import depolama from '../assets/images/services/depolama.jpg';
import sehirlerArasi from '../assets/images/services/sehirler-arasi.jpg';

const Services = () => {
  const services = [
    {
      title: "Ev Taşıma",
      description: "Cihangir Nakliyat olarak, evinizi yeni bir başlangıca taşırken eşyalarınıza sizin kadar değer veriyoruz. Profesyonel ekibimizle eşyalarınızı dikkatle paketliyor, güvenli bir şekilde yeni adresinize ulaştırıyoruz. Stressiz bir taşınma deneyimi için buradayız.",
      image: evTasima,
    },
    {
      title: "Ofis Taşıma",
      description: "İş yerinizi taşırken zamanın değerini biliyoruz. Ofis eşyalarınızı hızlı, düzenli ve güvenli bir şekilde yeni adresinize taşıyoruz. İş akışınızı kesintiye uğratmadan, profesyonel çözümler sunuyoruz.",
      image: ofisTasima,
    },
    {
      title: "Asansörlü Taşıma",
      description: "Yüksek katlı binalarda taşınma artık sorun değil! Modern asansörlü taşıma sistemlerimizle eşyalarınızı hızlı ve güvenli bir şekilde taşıyoruz. Hem zamandan tasarruf edin hem de eşyalarınıza zarar gelmesin.",
      image: asansorluTasima,
    },
    {
      title: "Depolama",
      description: "Eşyalarınızı geçici bir süre saklamak mı istiyorsunuz? Güvenli, temiz ve modern depolarımızla eşyalarınıza sizin yerinize göz kulak oluyoruz. İhtiyacınız olduğunda eşyalarınız hazır sizi bekliyor.",
      image: depolama,
    },
    {
      title: "Şehirler Arası Taşıma",
      description: "Türkiye'nin her noktasına güvenilir nakliyat hizmeti sunuyoruz. Şehirler arası taşımacılıkta deneyimli ekibimiz ve geniş araç filomuzla, eşyalarınızı yeni adresinize sorunsuz bir şekilde ulaştırıyoruz.",
      image: sehirlerArasi,
    }
  ];

  return (
    <div>
      {/* Sayfa Başlığı Banner */}
      <div className="bg-primary text-white py-16">
        <div className="container-custom text-center">
          <h1 className="text-4xl font-bold">Hizmetlerimiz</h1>
          <p className="mt-4 text-xl">Size En İyi Hizmeti Sunuyoruz</p>
        </div>
      </div>

      {/* Hizmetler Listesi */}
      <section className="py-16">
        <div className="container-custom">
          <div className="space-y-16">
            {services.map((service, index) => (
              <div 
                key={index}
                className={`flex flex-col ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                } gap-8 items-center`}
              >
                {/* Görsel Alanı */}
                <div className="md:w-1/2">
                  <div className="rounded-lg overflow-hidden shadow-lg">
                    <img 
                      src={service.image} 
                      alt={service.title} 
                      className="w-full h-full object-cover"
                      loading={index === 0 ? "eager" : "lazy"}
                    />
                  </div>
                </div>

                {/* İçerik Alanı */}
                <div className="md:w-1/2">
                  <h2 className="text-3xl font-bold text-primary mb-4">{service.title}</h2>
                  <p className="text-gray-700 leading-relaxed">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Çağrı Alanı */}
      <section className="bg-gray-50 py-16">
        <div className="container-custom text-center">
          <h2 className="text-3xl font-bold text-primary mb-6">
            Profesyonel Nakliyat Hizmeti İçin
          </h2>
          <p className="text-xl text-gray-700 mb-8">
            Hemen bizimle iletişime geçin, ücretsiz keşif ve fiyat teklifi alalım.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:+905393801469" 
              className="btn-primary"
            >
              Hemen Ara
            </a>
            <a 
              href="https://wa.me/905393801469?text=Merhaba%20Cihangir%20Nakliyat,%20nakliyat%20hizmetleri%20hakkında%20bilgi%20almak%20istiyorum." 
              className="bg-green-500 hover:bg-green-600 text-white py-2 px-6 rounded-md transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              WhatsApp'tan Yaz
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services; 